import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PullToRefreshComponent } from './pull-to-refresh.component';
import { RefreshWebComponent } from './refresh-web/refresh-web.component';

@NgModule({
  declarations: [PullToRefreshComponent, RefreshWebComponent],
  exports: [PullToRefreshComponent, RefreshWebComponent],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, FormsModule, IonicModule, RouterModule]
})
export class PullToRefreshModule { }
